import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginRoutingModule } from './login-routing.module';
import { LoginMainComponent } from './components/login-main/login-main.component';
import { LoginFormComponent } from './components/login-form/login-form.component';

@NgModule({
  imports: [
    CommonModule,
    LoginRoutingModule,
    FormsModule
  ],
  declarations: [LoginMainComponent, LoginFormComponent]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/modules/login/login.module.ts